export const projectList = [
    {
        name: 'Python Translator with Deepl',
        stack: 'Python, Flask, Sass',
        github: 'https://github.com/lhotovy/python_translator',
        web: 'https://lhotovy.pythonanywhere.com/'
    },
    {
        name: "Webster's E-Shop",
        stack: 'Next.js, Typescript, Tailwindcss, Prisma, MongoDB',
        github: 'https://github.com/lhotovy/websters-eshop',
        web: 'https://websters-eshop.vercel.app/'
    }
];